import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { civicCapabilities } from '../../data/research';
import { fadeUp } from '../../utils/motion';
export function CognarchicFoundation() {
  return <section className="bg-navy-deep text-white py-20 lg:py-28" data-id="element-1182" data-mp="7hi385p6b93j">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1183" data-mp="2krnxkl70hj6">
        <motion.div {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-16" data-id="element-1184" data-mp="2mb7pl625app">
          <h2 className="lg:col-span-5 font-heading font-bold text-4xl lg:text-5xl tracking-tight leading-tight" data-id="element-1185" data-mp="3ozjflaa7d41d">
            A possible foundation for the Cognarchic State
          </h2>
          <div className="lg:col-span-7 space-y-5" data-id="element-1186" data-mp="3jy3tdewagrhe">
            <p className="text-xl text-white leading-relaxed" data-id="element-1187" data-mp="3fzwaoei9lg3k">
              The Cognarchic State is a proposed governance model centered on
              developing judgment and aligning responsibility with demonstrated
              capability. SKP could provide its knowledge foundation: approved
              capability definitions, research, rubrics, policy versions, role
              requirements, and the relationships among them.
            </p>
            <p className="text-lg text-white/75 leading-relaxed" data-id="element-1188" data-mp="10qb6f313sev2">
              A complete civic application would require additional systems to
              assess people, deliver services, manage cases, and independently
              review consequential decisions. Our research architecture groups
              that work into five major capabilities.
            </p>
            <a href="https://cognarchicstate.org" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 pt-2 font-semibold text-teal hover:text-white transition-colors duration-150 whitespace-nowrap" data-id="element-1189" data-mp="1xfshxymrov4o">
              Learn more about the Cognarchic State
              <ArrowUpRight size={18} aria-hidden="true" data-id="element-1190" data-mp="d10d26m31mqy" />
              <span className="sr-only" data-id="element-1191" data-mp="cydtt9ptxisw">(opens cognarchicstate.org in a new tab)</span>
            </a>
          </div>
        </motion.div>

        <ol className="border-t border-white/15" data-id="element-1192" data-mp="3l1wpyew56cq3">
          {civicCapabilities.map((capability, index) => <motion.li key={capability.title} {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-16 border-b border-white/15 py-8" data-id="element-1193" data-mp="3gaoc96ns4574" data-mpi={index}>
              <div className="lg:col-span-5 flex gap-5" data-id="element-1194" data-mp="36elf6f7sawr1">
                <span className="font-heading font-extrabold text-3xl text-teal leading-none w-8 shrink-0" data-id="element-1195" data-mp="31efgwg70ebzz">
                  {index + 1}
                </span>
                <h3 className="font-heading font-bold text-xl lg:text-2xl" data-id="element-1196" data-mp="2xddn4evv2s5e">{capability.title}</h3>
              </div>
              <p className="lg:col-span-7 text-white/75 leading-relaxed" data-id="element-1197" data-mp="2sfu3t0kb3p6l">{capability.body}</p>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}